import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Objects, Parts, Types} from "components";
import API from "@beardeddevops/react.api";
import moment from "moment-timezone";
import {confirmAlert} from "react-confirm-alert";
import {Button, Card, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import UserRoles from "../../constants/UserRoles";
import {CardContent, Tooltip} from "@material-ui/core";
import CardActions from "@material-ui/core/CardActions";

/**
 *  @property {Customers_Object} state
 *  @property {object} model
 *  @property {Customers_Properties} model.properties
 *  @property {Customers_Is} model.is
 *  @property {Customers_Has} model.has
 */
export default class Customer extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Customers._name);
		this.redirect = this.props.baseUrl;
	}

	/**
	 * @param prevProps
	 * @param {Customers_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if (typeof this.props.updateName === 'function') {
			this.props.updateName(this.state.name);
		}
	}

	//Note: Doesn't need a form() function. Only ever used in a modal
	render() {
		/**
		 * @param {Customers_Properties} data
		 */
		let {properties} = this.model
		/**
		 * @type {Customers_Object} object
		 */
		let object = this.state
		let {loading} = this.state
		let {disableFields} = this.props
		//currently this is only passed via CheckoutCustomer

		return (
			<Card style={{overflow: 'visible'}}>
				<CardContent style={{paddingBottom: 0}}>
					<fieldset>
						<div className={"row"}>
							<div className={"col"}>

								<h4 className={'section-title'}>Contact Information</h4>

								<div className={'row'}>
									<div className={disableFields ? 'col-7' : 'col-9'}>
										<div className="form-group">
											<Framework.Elements.TextField
												disabled={disableFields}
												property={properties.name}
												value={object.name}
												error={object.name_error}
												update={this.handleTextFieldPropertyUpdate}
												label={'Name'}
											/>
										</div>
									</div>
									<div className={disableFields ? 'col-5' : 'col-3'}>
										<div className="form-group">
											<Framework.Elements.PhoneNumber
												disabled={disableFields}
												property={properties.phone}
												value={object.phone}
												error={object.phone_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
								</div>

								<div className={'row'}>
									<div className={disableFields ? 'col-7' : 'col-9'}>
										<div className="form-group">
											<Framework.Elements.EmailAddress
												disabled={disableFields}
												property={properties.email}
												value={object.email}
												error={object.email_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
									<div className={disableFields ? 'col-5' : 'col-3'}>
										<div className={"form-group"}>
											<Framework.Elements.Date
												disabled={disableFields}
												label={"Birth Date"}
												value={object.birth_date}
												error={object.birth_date_error}
												property={properties.birth_date}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
								</div>

							</div>
						</div>
					</fieldset>
				</CardContent>
				<CardActions style={{justifyContent: 'flex-end', padding: '14px'}}>
					{this.props.goBack &&
						<Button color="secondary" onClick={() => (this.props.history.goBack())}>Back</Button>
					}
					{this.props.noDelete &&
						<Button color="danger" data-id={this.props.dataIdDelete} onClick={this.handleDelete}>{this.props.deleteText ? this.props.deleteText : "Delete"}</Button>
					}
					{this.props.hideSave ? null : this.props.dataIdSave ?
						<Button color="primary" data-id={this.props.dataIdSave} onClick={this.handleSubmit}>Save</Button>
						:
						<Button color="primary" onClick={this.handleSubmit}>Save</Button>
					}
				</CardActions>
				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</Card>
		)
	}
}

